<template>
  <v-container>
    <PageHeader subtitle="Manage time series tags across the system." />
    <Subheader v-model="search" title="Time Series Tags" search="Time Series Tags">
      <v-btn color="success" @click="showAddType = true">
        <v-icon class="mr-1">add</v-icon>
        {{ $t('Button.Add_a_new_Tag') }}
      </v-btn>
    </Subheader>

    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="tagList" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <td>
              <v-icon class="mr-1">{{ props.item.IconPath }}</v-icon>
              {{ props.item.TagName }}
            </td>
            <td>{{ props.item.IconPath }}</td>
            <td class="text-xs-right">
              <v-flex>
                <v-btn depressed small @click="clickEditTag(props.item)">{{ $t('Button.Manage_Tag') }}</v-btn>
                <!-- <v-btn color="delete" dark @click="deleteRole = props.item; dialog = true">Delete Type</v-btn> -->
              </v-flex>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showAddType" persistent max-width="600px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationTimeSeriesTagManage.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showAddType = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation class="fullScreenWidth">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 pa-3>
                <v-text-field label="Tag Name" v-model="newTag.TagName" :rules="tagNameRules"></v-text-field>
                <v-select label="Icon Path" v-model="newTag.IconPath" :items="iconList">
                  <template slot="selection" slot-scope="data">
                    <v-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-avatar>
                    {{ data.item }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>{{data.item}}</v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="addTag()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUpdateType" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationTimeSeriesTagManage.editTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showUpdateType = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid2" ref="form2" lazy-validation class="fullScreenWidth">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 pa-3>
                <v-text-field label="Tag Name" v-model="editTag.TagName" :rules="editTagNameRules"></v-text-field>
                <v-select label="Icon Path" v-model="editTag.IconPath" :items="iconList">
                  <template slot="selection" slot-scope="data">
                    <v-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-avatar>
                    {{ data.item }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>{{data.item}}</v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="updateTag()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar class="snackbarAdjust" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import SideMenuUtil from '@/components/mixins/SideMenuUtil'
  const stations = createNamespacedHelpers('stations')
  export default {
    mixins: [SideMenuUtil],
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: 10,
        },
        headers: [{
          align: 'left',
          text: 'Tag Name',
          value: 'TagName',
        },
        {
          align: 'left',
          text: 'Icon Path',
          value: 'IconPath',
        },
        {
          sortable: false,
          text: '',
          value: '',
        },
        ],
        dialog: false,
        showAddType: false,
        showUpdateType: false,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        valid: true,
        valid2: true,
        newTag: {},
        editTag: {},
        tagListWithoutEdit: [],
        deleteRole: {},

        tagNameRules: [
          (v) => !!v || 'Tag name is required',
          (v) => this.tagList.find(x => x.TagName == v) == null || 'The tag name already exists',
        ],

        editTagNameRules: [
          (v) => !!v || 'Tag name is required',
          (v) => this.tagListWithoutEdit.find(x => x.TagName == v) == null || 'The tag name already exists',
        ],
      }
    },
    mounted() {
      if (!this.tagList || !this.tagList.length) {
        this.getTagList()
      }
    },
    computed: {
      ...stations.mapGetters(['tagList', 'iconList']),
    },
    methods: {
      ...stations.mapActions(['getTagList', 'putUpdateTag', 'postAddTag']),
      addTag() {
        if (this.$refs.form.validate()) {
          let options = {
            data: {
              Id: null,
              TagName: this.newTag.TagName,
              IconPath: this.newTag.IconPath ? this.newTag.IconPath : 'help',
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationTimeSeriesTagManage.addTagSuccessMsg', { msg: this.newTag.TagName })
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
            },
            failedCb: err => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.postAddTag(options)
        }
      },
      updateTag() {
        if (this.$refs.form2.validate()) {
          let options = {
            data: {
              Id: this.editTag.Id,
              TagName: this.editTag.TagName,
              IconPath: this.editTag.IconPath ? this.editTag.IconPath : 'help',
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationTimeSeriesTagManage.updateTagSuccessMsg', { msg: this.editTag.TagName })
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
              this.continuousStationCategoryChange()
            },
            failedCb: (err) => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.putUpdateTag(options)
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.showAddType = false
        this.showUpdateType = false
      },
      clickEditTag(data) {
        this.showUpdateType = true
        this.editTag = JSON.parse(JSON.stringify(data))
        this.tagListWithoutEdit = this.removeEditTag(data)
      },
      removeEditTag(data) {
        let tagList = JSON.parse(JSON.stringify(this.tagList))
        let tag = tagList.find(x => x.TagName == data.TagName)
        let i = tagList.indexOf(tag)
        tagList.splice(i, 1)
        return tagList
      },
    },
  }
</script>

<style scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .fullScreenWidth {
    width: 100%;
  }

  .fontSize {
    font-size: 14px !important;
  }

  .titleAdjust {
    padding-top: 50px;
  }

  .iconAdjust {
    padding-bottom: 10px;
  }

  .snackbarAdjust {
    text-align: center;
  }
</style>